import { render, staticRenderFns } from "./Federation.vue?vue&type=template&id=17bd19fa&scoped=true"
import script from "./Federation.vue?vue&type=script&lang=js"
export * from "./Federation.vue?vue&type=script&lang=js"
import style0 from "./Federation.vue?vue&type=style&index=0&id=17bd19fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bd19fa",
  null
  
)

export default component.exports